import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LatestFeed from "./components/LatestFeed";
import HotSpots from "./components/HotSpots";
import TopList from "./components/TopList";
import Categories from "./components/Categories";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("all");

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900 antialiased">
      <Navbar />
      <main>
        <Hero />
        <LatestFeed active={activeCategory} onSelect={setActiveCategory} />
        <HotSpots />
        <TopList />
        <Categories onPick={setActiveCategory} />
        <AboutSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}